import { SaopViewForm } from "../Core/saop-view-form";
import { SaopSifranti } from "../Components/saop-sifranti";


export class OPNRelacijeView extends SaopViewForm {
  private _saopSifranti:SaopSifranti;

    constructor(viewId:string,libName:string = ""){
        super(viewId,libName);
        this.title = this.translationService.translate("Relacije");
        this.addRecordEndpoint = "OpnRelations/Create";
        this.editRecordEndpoint = "OpnRelations/Edit";
        //this.deleteRecordEndpoint = "OpnRelations/Delete"; 
        //
        this._saopSifranti = new SaopSifranti();
        //
        this.afterViewShowSuccess = this.initView;
        this.afterSubmitSuccess = this.initView;        
      }


      setDictionary(){
        let dictionary:string[] = ["Relacije"];
        this.setTerminologyList(dictionary);
    } 

      public initView():void{
        this.setDictionary();  
        this.LoadViewEvents();
        this._saopSifranti.init();
      }

      public LoadViewEvents ():void{

      }

      //
}